import { asyncRequest } from './asyncRequest'
import { studentConstants } from './student.actions'

export const studentAuthConstants = {
    STUDENT_REGISTER: new asyncRequest('STUDENT_REGISTER'),
    STUDENT_LOGIN: new asyncRequest('STUDENT_LOGIN'),
    STUDENT_LOGIN_WITH_ACCESS_CODE: new asyncRequest('STUDENT_LOGIN_WITH_ACCESS_CODE'),
    STUDENT_LOGOUT: new asyncRequest('STUDENT_LOGOUT'),
    STUDENT_FORGOT_PASSWORD_PIN: new asyncRequest('STUDENT_FORGOT_PASSWORD_PIN'),
    STUDENT_FORGOT_PASSWORD_ACCESS_CODE: new asyncRequest('STUDENT_FORGOT_PASSWORD_ACCESS_CODE'),
    STUDENT_UPDATE_FORGOT_PASSWORD: new asyncRequest('STUDENT_UPDATE_FORGOT_PASSWORD'),
    STUDENT_SHOULD_REGISTER: new asyncRequest('STUDENT_SHOULD_REGISTER'),
    STUDENT_START_OVER: new asyncRequest('START_OVER'),
    STUDENT_CLEAR_ERRORS: new asyncRequest('CLEAR_ERRORS'),
    STUDENT_CHANGE_PASSWORD: new asyncRequest('STUDENT_CHANGE_PASSWORD'),
}

export const studentAuthActions = {
    studentLogin(email, password, dashboardLanguageId, appVersion) {
        return {
            type: studentAuthConstants.STUDENT_LOGIN.REQUEST,
            payload: {
                email: email,
                password: password,
                userDevice: {
                    DeviceGuid: JSON.parse(localStorage.getItem('deviceGuid'))?.deviceGuid,
                    AppVersion: appVersion,
                    AppLanguageId: dashboardLanguageId,
                },
            },
        }
    },
    studentLoginWithAccessCode(accessCode, dashboardLanguageId, appVersion) {
        return {
            type: studentAuthConstants.STUDENT_LOGIN_WITH_ACCESS_CODE.REQUEST,
            payload: {
                accessCode: accessCode,
                userDevice: {
                    DeviceGuid: JSON.parse(localStorage.getItem('deviceGuid'))?.deviceGuid,
                    AppVersion: appVersion,
                    AppLanguageId: dashboardLanguageId,
                },
            },
        }
    },

    studentRegister(email, password, allowEmailNotifications, dashboardLanguageId, appVersion, termsAccepted) {
        return {
            type: studentAuthConstants.STUDENT_REGISTER.REQUEST,
            payload: {
                email: email,
                newPassword: password,
                allowedToSendEmailNotifications: allowEmailNotifications,
                termsAccepted: termsAccepted === true,
                userDevice: {
                    DeviceGuid: JSON.parse(localStorage.getItem('deviceGuid'))?.deviceGuid,
                    AppVersion: appVersion,
                    AppLanguageId: dashboardLanguageId,
                },
            },
        }
    },

    studentShouldRegister(email) {
        return {
            type: studentAuthConstants.STUDENT_SHOULD_REGISTER.REQUEST,
            payload: {
                email: email,
            },
        }
    },

    studentForgotPasswordPin(email) {
        return {
            type: studentAuthConstants.STUDENT_FORGOT_PASSWORD_PIN.REQUEST,
            payload: {
                email,
            },
        }
    },
    studentForgotPasswordAccessCode(email) {
        return {
            type: studentAuthConstants.STUDENT_FORGOT_PASSWORD_ACCESS_CODE.REQUEST,
            payload: {
                email,
            },
        }
    },
    studentUpdateForgotPassword(email, pin, newPassword) {
        return {
            type: studentAuthConstants.STUDENT_UPDATE_FORGOT_PASSWORD.REQUEST,
            payload: {
                email,
                pin,
                newPassword,
            },
        }
    },
    studentStartOver() {
        return {
            type: studentAuthConstants.STUDENT_START_OVER.REQUEST,
            payload: {},
        }
    },
    studentClearErrors() {
        return {
            type: studentAuthConstants.STUDENT_CLEAR_ERRORS.REQUEST,
            payload: {},
        }
    },
    studentLogout() {
        return {
            type: studentAuthConstants.STUDENT_LOGOUT.REQUEST,
        }
    },
    changePassword(email, newPassword, dashboardLanguageId, appVersion) {
        return {
            type: studentAuthConstants.STUDENT_CHANGE_PASSWORD.REQUEST,
            payload: {
                email,
                newPassword,
                userDevice: {
                    DeviceGuid: JSON.parse(localStorage.getItem('deviceGuid'))?.deviceGuid,
                    AppVersion: appVersion,
                    AppLanguageId: dashboardLanguageId,
                },
            },
        }
    },
}
